module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av755-238d3fff79dd688e71daabc1fdb9eb6c.jpg";